<div class="viewer-draw d-flex flex-column">
  <zbp-button-component id="writeButton"
                        [ngbPopover]="popoverControl?.popoverContent"
                        popoverClass="viewer-control-popover"
                        [popperOptions]="popperOptions"
                        [autoClose]="'outside'"
                        (shown)="showPopover()"
                        (hidden)="closePopover()"
                        [placement]="isDesktop ? 'right' : 'top'"
                        container="body"
                        [openDelay]="0"
                        [closeDelay]="0"
                        [theme]="'viewerControl'"
                        [borderRadius]="'0'"
                        [label]="buttonText"
                        [ariaLabel]="'Writing: ' + ariaLabel"
                        [ariaExpanded]="isPopoverOpen"
                        [iconPosition]="'top'"
                        [iconName]="icon"
                        #popover="ngbPopover"
                        [customClass]="'viewer-asset-control-button'"
  >
  </zbp-button-component>

  <zbp-viewer-control-popover #popoverControl="ControlPopoverComponent"
                              title="writing"
                              (shouldClosePopover)="popover.close()"
                              [hidden]="true">
    <div class="writing-content">
      <div class="tool-buttons">
        <zbp-button-component id="penToolButton"
                              type="button"
                              [ariaLabel]="penIsActive ? this.currentColor.name + ' Pen, Enabled' : 'Pen'"
                              [disabled]="!enabled"
                              (clickHandler)="setActiveTool('draw')"
                              [extraHorizontalPadding]="true"
                              [theme]="penIsActive ? 'viewerPopoverActive' : 'viewerPopover'"
                              [iconPosition]="'top'"
                              [label]="'Pen'"
                              [iconName]="zbpIconNames.pencil2"
        />
        <zbp-button-component id="eraserToolButton"
                              type="button"
                              [ariaLabel]="eraserIsActive ? 'Eraser, Enabled' : 'Erase'"
                              [disabled]="!enabled"
                              (clickHandler)="setActiveTool('erase')"
                              [extraHorizontalPadding]="true"
                              [theme]="eraserIsActive ? 'viewerPopoverActive' : 'viewerPopover'"
                              [iconPosition]="'top'"
                              [label]="'Eraser'"
                              [iconName]="zbpIconNames.eraserIcon2"
        />
        <zbp-button-component id="clearButton"
                              type="button"
                              [ariaLabel]="'Clear'"
                              [disabled]="!enabled"
                              (clickHandler)="clear()"
                              [extraHorizontalPadding]="true"
                              [theme]="'viewerPopover'"
                              [iconPosition]="'top'"
                              [label]="'Clear'"
                              [iconName]="zbpIconNames.trash_can2"
        />
      </div>
      <!-- Color palette - hide if eraser tool is selected -->
      @if (activeTool !== DrawingTools.erase) {
        <div class="color-palette">
          @for (color of colors; track color) {
            <zbp-button-component
              [backgroundColor]="color.color"
              borderRadius="50%"
              [theme]="color.color === currentColor.color ? 'colorPaletteActive' : 'colorPalette'"
              (clickHandler)="selectColor(color.color)"
              [iconName]="color.color === currentColor.color ? zbpIconNames.check_mark_thick : ''"
              [iconPrimaryColor]="currentColor.color === DrawingColors.black ? 'white' : 'black'"
              [tooltip]="color.name + ' Ink'"
              [ariaLabel]="color.color === currentColor.color ? color.name + ' selected' : color.name + ' not selected'"
            />
          }
        </div>
      }
      <div class="brush-sizes">
        @for (option of brushSizes; track option) {
          <zbp-button-component
            [backgroundColor]="getBrushBackgroundColor()"
            [theme]="currentSize?.size === option.size ? 'brushSizeCircleActive' : 'brushSizeCircle'"
            (clickHandler)="selectSize(option)"
            [tooltip]="activeTool === DrawingTools.erase ? 'Eraser Size ' + option.name : 'Brush Size ' + option.name"
            [iconName]="activeTool === DrawingTools.erase ? zbpIconNames.circleDashedIcon : zbpIconNames.circleFillIcon"
            iconSize="font-size"
            [fontSize]="option.fontSize"
            [iconPrimaryColor]="activeTool === DrawingTools.erase ? 'white' : currentColor.color"
            [ariaLabel]="option.size === currentSize?.size ? option.name + ' selected' : option.name + ' not selected'"
          />
        }
      </div>
    </div>
  </zbp-viewer-control-popover>
</div>
